<template>
  <div class="popup_wrap" style="width:800px; height:520px;">
    <button
      class="layer_close"
      @click="popClose()"
    >
      close
    </button>
    <div class="popup_cont">
      <h1 class="page_title">
        {{ $t('msg.SETT070G010.014') }}
      </h1>
      <div class="content_box">
        <p class="color_red">* {{ $t('msg.SETT070G010.037') }}</p> <!-- EOR(수리견적서)는 필수 첨부 항목입니다. -->
        <p class="color_red mb10">* {{ $t('msg.SETT070G010.038') }}</p> <!-- EOR 첨부파일은 xlsx, xls, txt, png, jpg, jpeg, pdf 형식만 등록 가능합니다. -->
        <DEXT5Upload
          ref="dextupload_mr"
          :id="component_id"
          width="100%"
          height="200px"
          :category="false"
          :single="singleFileYn"
          :file-info="parentInfo"
          :is-show-pop="isShowPop"
          :category-info="[]"
          kind-detail
          :detail-info="detailList"
          :eor-ext="eorExt"
        />
      </div>
    </div>
    <div class="mt10 text_center">
      <a class="button blue lg" @click="popClose()">{{ $t('msg.SETT070G010.015') }}</a>
    </div>
  </div>
</template>

<script>
import DEXT5Upload from '@/components/common/DEXT5UploadForMr'
import commons from '@/api/services/commons'

export default {
  name: 'MrWaiverUploadPop',
  components: {
    DEXT5Upload,
    EFileUploader: () => import('@/components/common/EFileUploader')
  },
  props: {
    singleFileYn: {
      type: Boolean,
      default: false
    },
    parentInfo: {
      type: Array,
      default: function () {
        return []
      }
    },
    isShowPop: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isShowUpPop: false,
      detailList: [], // PIC Detail (EQ082)
      eorExt: ['xlsx', 'xls', 'txt', 'png', 'jpg', 'jpeg', 'pdf']
    }
  },
  computed: {
    component_id () {
      if (typeof window.upload_component_cnt === 'undefined') {
        window.upload_component_cnt = 0
      }
      window.upload_component_cnt++
      const c = window.upload_component_cnt

      return `upload_com_id_${c}`
    }
  },
  watch: {
    isShowPop: function () {
      // console.log(' watch isShowPop :: ' + this.isShowPop)
      // console.log(this.parentInfo)
    }
  },
  created () {
    console.log('created')
    commons.getCommonsCodesCommon(['EQ082']).then(res => {
      // 공통코드 응답은 이름순이라 조회순서(Before stuffing → etc)로 정렬
      this.detailList = (res.EQ082 || []).sort((a, b) => Number(a.inqOrd) - Number(b.inqOrd))
    })
  },
  mounted: function () {
    console.log('mounted')
  },
  methods: {
    setFileInfo: function (parentInfo) {
      let $vm = this
      // console.log('setFileInfo parentInfo')
      // console.log(parentInfo)
      // console.log(this.parentInfo)
      //parentInfo = this.parentInfo
      if (this.$refs.dextupload_mr !== undefined) {
        this.$refs.dextupload_mr.setFileInfo(parentInfo)
      //  // this.$emit('arrange')
      }
    },
    popClose: function () {
      let file = this.$refs.dextupload_mr.getFileInfo()
      // console.log('file ==> ', file)
      //this.$refs.dextupload_mr.ResetDext()
      const errMsg = this.checkKindDetail(file)
      if (errMsg !== '') {
        this.$ekmtcCommon.alertDefault(errMsg)
        return false
      }

      this.$emit('selectFunc', file)

      this.$emit('close', this.parentInfo)

      return false
    },
    // 새로 올렸거나 Kind/Detail 을 바꾼 파일만 검사 (이전에 올린 PIC 은 Detail 없이 저장돼 있음)
    checkKindDetail: function (files) {
      for (const f of files) {
        const changed = f.newFlag === 'Y' || f.fileKndCd !== f.orgKndCd || f.fileDtlCd !== f.orgDtlCd
        if (!changed) {
          continue
        }

        const fileNm = '<br>(' + f.originalName + ')'
        if (!f.fileKndCd) {
          return this.$t('msg.SETT070G010.039') + fileNm // Kind 를 선택해 주세요.
        }
        if (f.fileKndCd === '02' && !f.fileDtlCd) {
          return this.$t('msg.SETT070G010.040') + fileNm // PIC 의 Detail 을 선택해 주세요.
        }
        if (f.fileKndCd === '01' && !this.$refs.dextupload_mr.isEorExt(f.originalName)) {
          return this.$t('msg.SETT070G010.038') + fileNm
        }
      }
      return ''
    }
  }
}
</script>
<style scoped>
.DEXT_fiVe_UP_ly_wrapper{
  z-index: 99999999 !important;
}
</style>
